import { Box, IconButton, Tooltip } from "@mui/material"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../../../utils/icons"
import { useStyles } from "../../styles"
import { useState } from "react"
import { OpenDrawer } from "../../types"


const useTables = () => {

    const { t } = useTranslation()
    const styles = useStyles()

    const [openDrawer, setOpenDrawer] = useState<OpenDrawer>({
      setting: false,
      user: {
        id: [],
        name: undefined,
        totalUsers: 0,
        notifications: {
          email:false,
          app: false
        }
      },
    })

    const handleOpenDrawer = ({
      user,
    }: {
      user: {
        id: number[] | string[]
        name?: string
        totalUsers?: number
        notifications: {
          email: boolean,
          app: boolean
        }
      }
    }) => {

        setOpenDrawer((prev) => ({
          ...prev,
          setting: true,
          user,
        }))
      
    }

    const closeDrawer = () => {
      setOpenDrawer((prev) => ({
        ...prev,
        setting: false,
      }))
    }

    const column = [
      {
        id: 'users',
        label: t('general.tags.name'),
      },
      {
        id: 'curp',
        label: t('general.tags.curp'),
      },
      {
        id: 'role',
        label: t('general.tags.role'),
      },
      {
        id: 'userType',
        label: t('general.tags.userType'),
      },
      {
        id: 'division',
        label: t('general.tags.division'),
      },
      {
        id: 'settings',
        label: t('department.form.tabs.settings'),
        /* minWidth: 50, */
        contentColumn: {
          justifyContent: 'center',
        },
        column: () => {
          return (
            <Box sx={styles.setting}>
              {!!selectedUsers.length && (
                <Tooltip title={t('reportFolio.notificationCenter.configureNotifications')}>
                  <span>
                    <IconButton
                      className='setting'
                      disabled={!selectedUsers.length}
                      onClick={() => { 
                        handleOpenDrawer({
                          user: {
                            id: selectedUsers,
                            totalUsers: selectedUsers.length,
                            notifications: {
                              email: false,
                              app: false
                            }
                          },
                        })
                      }}
                    >
                      {icons('setting')}
                    </IconButton>
                  </span>
                </Tooltip>
              ) }      
            </Box>
          )
        },
        renderCell: (params: any) => {
          return (
            <Box sx={styles.setting}>
              <Tooltip title={t('reportFolio.notificationCenter.configureNotifications')}>
                <IconButton
                  /* className='setting' */
                  onClick={() => {
                    handleOpenDrawer({
                      user: {
                        id: [params?.row?.id],
                        name: params?.row?.users,
                        notifications: {
                          email: params?.row?.email,
                          app: params?.row?.app
                        }
                      },
                    })
                  }}
                >
                  {icons('setting')}
                </IconButton>
              </Tooltip>
      
            </Box>
          )
        },
      },
      ]

  const [selectedUsers, setSelectedUsers] = useState<string[]>([])


return { column, openDrawer, closeDrawer, selectedUsers, setSelectedUsers }
}

export { useTables }
